import { GuardhouseErrorCodes } from './guardhouse-error-codes.type';

export const isGuardhouseInternalError = (errorCode: string): boolean => {
  switch (errorCode) {
    case GuardhouseErrorCodes.INTERNAL:
    case GuardhouseErrorCodes.INVALID_APP_DOMAIN:
      return true;
    default:
      return false;
  }
};

export const isGuardhouseTokenError = (errorCode: string): boolean => {
  switch (errorCode) {
    case GuardhouseErrorCodes.INVALID_TOKEN:
    case GuardhouseErrorCodes.INVALID_TOKEN_SIGNATURE:
    case GuardhouseErrorCodes.INVALID_TOKEN_EXPIRY:
      return true;
    default:
      return false;
  }
};

export const isGuardhouseScopeError = (errorCode: string): boolean => {
  switch (errorCode) {
    case GuardhouseErrorCodes.INVALID_SCOPE:
    case GuardhouseErrorCodes.UNAUTHORIZED_SCOPE:
      return true;
    default:
      return false;
  }
};

export const isGuardHouseMFAError = (errorCode: string): boolean => {
  switch (errorCode) {
    case GuardhouseErrorCodes.MFA_REQUIRED:
      return true;
    default:
      return false;
  }
};
